import React from 'react';
import News from '../news';

const Medianews = () => {

  return (
    <News
    pageTitle="Media News"
    metaTitle="Media News - FORLAND"
    bannerImage="/assets/images/bg1.png"
    to='/media-news'
     category='Media News'
  />
  );
};

export default Medianews;